import React, {ReactNode, ReactNodeArray, } from 'react';
import {connect} from 'react-redux';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareRedirectBlockData from '../../../Models/Content/SelfCareRedirectBlockData';

class SelfCareRedirect extends EpiComponent<SelfCareRedirectBlockData>
{
    constructor(props) {
        super(props);
    }

    public async componentDidMount()
    {
        try {
             /* check if redirection is needed */
            if (this.props.data.isActive.value === true) {
                var state = this.props.context.getStore().getState();
                var isPrivate = state.authentication.loginData.userDetails?.isPrivate || false;
                var isBusiness = state.authentication.loginData.userDetails?.IsContactPerson ||  false;

                if (this.props.data.isPlacedOnPrivate.value === true) {
                    if (isPrivate == false && isBusiness == false) {
                    /* nothing to do */
                    } else if (isPrivate == false) {
                        var content = await this.props.context.loadContentByPath(this.props.data.redirectToPath.value);
                        this.props.context.navigateTo(content);
                        return;
                    }
                }
                else if (this.props.data.isPlacedOnBusiness.value === true) {
                    if (isPrivate == false && isBusiness == false) {
                    /* nothing to do */
                    } else if (isBusiness == false) {
                        var content = await this.props.context.loadContentByPath(this.props.data.redirectToPath.value);
                        this.props.context.navigateTo(content);
                        return;
                    }
                }
            }
        }
        catch {}
    }


    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <div/>
        );
    }
}

    const mapStateToProps = (state) => {
        return {
            authentication: state.authentication,
        };
    };

    const mapDispatchToProps = {

    };

      export default connect(mapStateToProps, mapDispatchToProps)(SelfCareRedirect);



